/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { withNoTranslate } from "i18n/noTranslate";

import type { FC } from "react";

type AmountRow = {
  label: string;
  amount: number;
};

type Props = {
  rows: readonly AmountRow[];
  subText?: string;
};

export const AmountSummaryTable: FC<Props> = ({ rows, subText }) => {
  const { t } = useI18n();
  const classes = styles();
  const totalAmount = rows.reduce((total, { amount }) => total + amount, 0);

  return (
    <dl css={classes.root}>
      {rows.map(({ label, amount }) => (
        <div key={label} css={classes.row}>
          <dt>{label}</dt>
          <dd {...withNoTranslate()}>{formatAmount(amount)}</dd>
        </div>
      ))}
      <div css={[classes.row, classes.total]}>
        <dt>
          {t("common.total")}
          {subText}
        </dt>
        <dd {...withNoTranslate()}>{formatAmount(totalAmount)}</dd>
      </div>
    </dl>
  );
};

const formatAmount = (amount: number) => `¥${amount.toLocaleString()}`;

const styles = () => {
  return {
    root: css`
      margin: 0;
      border: 1px solid #a3a3a3;
    `,
    row: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      min-height: 48px;
      padding: 10px 12px;
      & + & {
        border-top: 1px solid #f0f0f0;
      }
      dt {
        color: #5c5c5c;
        font-size: 14px;
        line-height: 1.5;
      }
      dd {
        flex: none;
        margin: 0;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
        text-align: right;
      }
      @media screen and (min-width: 768px) {
        padding: 12px 16px;
      }
    `,
    total: css`
      background-color: #f0f0f0;
      dt {
        color: #222;
        font-weight: bold;
      }
      dd {
        font-size: 18px;
      }
    `,
  };
};
